((Drupal, debounce) => {

  /**
   * Set up the Side-Nav section functionality.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.gliSidenavSection = {
    attach (context) {
      const mobileBreakpoint = 850;

      const sections = once('gli-sidenav-section', '.paragraph--type--sidenav-section', context);
      const sectionGroups = [];
      let index = 0;
      sectionGroups[index] = [];
      sections.forEach(paragraph => {
        sectionGroups[index].push(paragraph);
        if (!paragraph.nextElementSibling?.classList.contains('paragraph--type--sidenav-section')) {
          // Start a new group.
          index++;
          sectionGroups[index] = [];
        }
      });

      sectionGroups.forEach(group => {
        if (group.length < 2) {
          // Skip groups with 1 or no elements.
          return;
        }

        const navItems = [];
        for (let i = 0; i < group.length; i++) {
          const element = group[i];
          const title = element.dataset.title;
          navItems.push({
            contentId: element.dataset.contentId,
            title: title
          });
        }

        const hasNextElement = group.at(-1)?.nextElementSibling != null;

        const wrapper = document.createElement('div');
        wrapper.classList.add('sidenav-section__wrapper');
        const contentWrapper = document.createElement('div');
        contentWrapper.classList.add('sidenav-section__content-area');
        wrapper.appendChild(contentWrapper);

        const firstElement = group.shift();
        firstElement.parentNode.insertBefore(wrapper, firstElement);
        contentWrapper.appendChild(firstElement);

        for (let i = 0; i < group.length; i++) {
          contentWrapper.appendChild(group[i]);
        }

        let navContent = '';
        navContent = navItems.reduce(
          (content, item) => content + `<li><a href="#${item.contentId}" data-content-id="${item.contentId}">${item.title}</a></li>`,
          navContent
        );
        let nextSectionLink = '';
        if (hasNextElement) {
          nextSectionLink = `<a class="skip-section">Skip to next section</a>`;
          wrapper.insertAdjacentHTML('beforeend', `<span class="next-section-anchor-point"></span>`);
        }
        const navHtml = `
          <div class="sidenav__menu">
            <div class="sticky-container">
              <ul>
                ${ navContent }
              </ul>
              ${ nextSectionLink }
            </div>
            <span class="current-option-mobile">Navigation</span>
          </div>
        `;

        wrapper.insertAdjacentHTML('afterbegin', navHtml);

        const links = wrapper.querySelectorAll('.sidenav__menu ul li a');
        const contents = wrapper.querySelectorAll('.sidenav-section__content-area');
        if (!links.length || !contents.length) {
          return;
        }

        wrapper.querySelector('.sidenav__menu').addEventListener('click', function() {
          if (window.innerWidth < mobileBreakpoint) {
            this.classList.toggle('is-active');
          }
        });

        wrapper.querySelector('.skip-section')?.addEventListener('click', event => {
          event.preventDefault();
          wrapper.querySelector('.next-section-anchor-point')?.scrollIntoView(true);
        });

        const resetMobileSectionNavMenu = () => {
          if (window.innerWidth < mobileBreakpoint) {
            wrapper.querySelector('.sidenav__menu').classList.remove('is-active');
          }
        }
        window.addEventListener('resize', debounce(resetMobileSectionNavMenu, 500));

        for (let i = 0; i < links.length; i++) {
          const link = links[i];
          link.addEventListener('gli.sectionClick', (event) => {
            const contentId = event.target.dataset.contentId;
            // Deactivate other section content.
            links.forEach(link => link.classList.remove('active'));
            contents.forEach(content => {
              content.classList.add('hide');
              content.querySelector('.field-title')?.classList.remove('active');
            });

            // Activate current link.
            event.target.classList.add('active');
            wrapper.querySelector('.current-option-mobile').innerHTML = event.target.innerHTML;
            const activeContent = wrapper.querySelector('.sidenav-section-content[data-content-id=' + contentId + ']');
            if (activeContent) {
              activeContent.classList.remove('hide');
              // Scroll to top of section.
              // gsap.to(window, { duration: .5, scrollTo: activeContent.querySelector('.anchor-point'), ease: 'none' });
              activeContent.querySelector('.anchor-point').scrollIntoView(true);
            }
            // Update URL.
            window.history.pushState(null, document.title, event.target.getAttribute('href'));
          });
          link.addEventListener('click', (event) => {
            event.preventDefault();
            event.target.dispatchEvent(new Event('gli.sectionClick'));
          });
        }

        // Set up scroll tracking.
        let lastScrollTop = window.scrollY; // Track last scroll position

        const scrollTrackObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const parId = entry.target.dataset.contentId;

              let currentScrollTop = window.scrollY;
              let scrollDirection = currentScrollTop > lastScrollTop ? 'up' : 'down';

              wrapper.querySelectorAll('.sidenav__menu ul li a').forEach(link => {
                link.classList.remove('active');
              });

              let activeLink = wrapper.querySelector(`.sidenav__menu [data-content-id="${parId}"]`);
              if (activeLink) {
                activeLink.classList.add('active');
                wrapper.querySelector('.current-option-mobile').innerHTML = activeLink.innerHTML;
              }

              lastScrollTop = currentScrollTop; // Update last scroll position
            }
          });
        });

        contentWrapper.querySelectorAll('.sidenav-section-content').forEach(interEl => {
          const interPoint = interEl.querySelector('.intersection-point');
          if (interPoint) {
            scrollTrackObserver.observe(interPoint);
          }
        });

        // Initial states.
        let activateInitialPanel = false;
        let contentId = null;
        let activeContent = null;
        if (window.location.hash && window.location.hash.startsWith('#par')) {
          contentId = window.location.hash.substring(1);
          activeContent = wrapper.querySelector('.section-content[data-content-id=' + contentId + ']');
          if (activeContent != null) {
            activateInitialPanel = true;
          }
        }

        if (activateInitialPanel) {
          const activeLink = wrapper.querySelector('.sidenav__menu [data-content-id="' + contentId + '"]');
          // Scroll to top of section section.
          setTimeout(() => {
            const anchorPoint = activeContent.querySelector('.anchor-point');
            if (anchorPoint != null) {
              anchorPoint.scrollIntoView(true);
            }
          }, 750);
        }
        else {
          // Activate the first element on page load.
          contentId = links[0].dataset.contentId;
          links.forEach(link => link.classList.remove('active'));
          links[0].classList.add('active');
          wrapper.querySelector('.current-option-mobile').innerHTML = links[0].innerHTML;
        }
      });
    }
  };
})(Drupal, Drupal.debounce);
